<!--
 * @Author: sf
 * @Date: 2021-04-15 11:56:17
 * @LastEditTime: 2021-04-15 11:57:01
 * @Description: 动态
 * @FilePath: \yijiu_shopmall_h5\src\views\home\dynamic.vue
-->
<template>
  <div class="n_continer">
    <!-- 搜索 -->
    <div class="n_commit">
      <div class="n_search">
        <van-icon name="search" />
        <input type="text" placeholder="搜索" @blur="blurFg" />
      </div>
    </div>
    <van-tabs @click="tabSelect" v-if="tabList.length > 0">
      <van-tab v-for="item in tabList" :title="item.name" :key="item.id">
        <div class="n_list">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="flex n_godds" v-for="item in list" :key="item.id" @click="jump(item.id)">
              <div class="n_goodsImg">
                <img :src="item.image" alt />
              </div>
              <div class="n_content">
                <div class="n_title">{{item.title}}</div>
                <div class="flex just_bennw n_time">
                  <p class="n_timetxt">{{item.release_time?item.release_time:''}}</p>
                  <div class="flex alitem_center">
                    <span class="iconfont iconsee"></span>
                    <div class="n_num">{{item.click}}</div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </van-tab>
    </van-tabs>
    <div class="n_noList" v-else>
      <img :src="imgPath+'yj_no@2x.png'" alt />
    </div>
  </div>
</template>

<script>
import { copyText } from '../../public/regular.js'
import { Toast } from 'vant'
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      tabList: [],
      page: 0,
      class_id: '', //筛选分类id
    }
  },
  created() {
    this.getTabsList()
    // this.getList()
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    copyTextFg(text) {
      copyText(text)
    },
    tabSelect(name, title) {
      this.class_id = this.tabList[name].id
      this.page = 1
      this.list = []
      this.getList()
      console.log(name, title)
    },
    blurFg(e) {
      this.page = 1
      this.list = []
      this.getList(e.target.value)
    },
    jump(id) {
      console.log(id)
      this.$router.push({ path: './dynamicDetails', query: { id: id } })
    },
    onClickLeft() {
      Toast('返回')
    },
    onClickRight() {
      Toast('按钮')
    },
    onLoad() {
      this.page++
      this.getList()
    },
    //获取文章列表
    async getList(cont) {
      let res = await this.http('ClientArticle.getArticleList', {
        title: cont,
        page: this.page,
        class_id: this.class_id,
      })
      this.loading = false
      this.list = this.list.concat(res.content.list)
      this.finished = res.content.list.length == 0
      console.log(res)
    },
    //获取tab
    async getTabsList() {
      let res = await this.http('ClientArticle.articleClassList', {
        is_one: 1,
        class_id: this.class_id,
      })
      this.tabList = res.content
      console.log(res)
    },
  },
}
</script>
<style scoped lang="scss">
.n_noList {
  display: block;
  width: 320px;
  height: 392px;
  margin: 120px auto;
}
.n_continer {
  width: 100vw;
  height: 100vh;
  background: #f7f8fa;
}
.n_commit {
  background: #ffffff;
  padding: 16px 32px;
}
.n_search {
  display: flex;
  align-items: center;
  background: rgba(247, 248, 250, 1);
  padding: 20px 24px;
  // padding: 16px 32px;
  // background-color: rgba(247, 248, 250, 1);
}
.n_search input {
  width: 100%;
  padding: 0 10px;
  background: rgba(247, 248, 250, 1);
}
.alitem_center {
  align-items: center;
}
.just_bennw {
  justify-content: space-between;
}
.n_list {
  padding: 30px 20px;
}
.n_godds {
  padding: 20px;
  background: rgba(255, 255, 255, 1);
  margin-bottom: 20px;
}
.n_goodsImg {
  width: 180px;
  height: 180px;
}
img {
  width: 100%;
  height: 100%;
}
.n_content {
  flex: 1;
  margin-left: 30px;
}
.n_title {
  height: 75px;
  font-size: 28px;
  color: #333333;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.n_time {
  margin-top: 54px;
}
.n_timetxt {
  font-size: 28px;
  color: #969799;
}
.n_num {
  font-size: 20px;
  color: #999999;
  margin-left: 8px;
}
.iconsee {
  font-size: 32px;
}
</style>